import { c as _c } from "react/compiler-runtime";
import type { ElementType, HTMLAttributes, ReactElement } from 'react';
import { cn } from '#cn';
import { alignClasses, gapClasses, type LayoutAlign, type LayoutGap } from './layout-classes';
type GridCols = 1 | 2 | 3 | 4 | 5 | 6 | 12;
type GridProps = HTMLAttributes<HTMLElement> & {
  cols?: GridCols;
  gap?: LayoutGap;
  align?: LayoutAlign;
  as?: ElementType;
};
const colsClasses: Record<GridCols, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
  6: 'grid-cols-6',
  12: 'grid-cols-12'
};

/** A CSS grid layout primitive with a fixed column count (`cols`) and the shared gap/align scale. */
export const Grid = t0 => {
  const $ = _c(18);
  let align;
  let children;
  let className;
  let cols;
  let gap;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      cols,
      gap,
      align,
      as: t1,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = align;
    $[2] = children;
    $[3] = className;
    $[4] = cols;
    $[5] = gap;
    $[6] = props;
    $[7] = t1;
  } else {
    align = $[1];
    children = $[2];
    className = $[3];
    cols = $[4];
    gap = $[5];
    props = $[6];
    t1 = $[7];
  }
  const Tag = t1 === undefined ? "div" : t1;
  const t2 = cols && colsClasses[cols];
  const t3 = gap !== undefined && gapClasses[gap];
  const t4 = align && alignClasses[align];
  let t5;
  if ($[8] !== className || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = cn("grid", t2, t3, t4, className);
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== Tag || $[14] !== children || $[15] !== props || $[16] !== t5) {
    t6 = <Tag className={t5} {...props}>{children}</Tag>;
    $[13] = Tag;
    $[14] = children;
    $[15] = props;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};